import React from "react";
import { Box } from "@chakra-ui/react";
import CmsPageTitle from "@/utils/CmsPageTitle";
import ContainerBox from "@/utils/ContainerBox";

const LegalNotice = () => {
  return (
    <Box>
      <CmsPageTitle title="Legal Notice"/>
      <ContainerBox bgColor="bg-gray" Style=" gap-4 sm:gap-8">
        <Box className="container mx-auto">
          <Box className="py-4">
            <p className="mb-3">Welcome to Skill Sour! These Terms and Conditions ("Terms") govern your use of the Skill Sour platform ("Platform"), where users can offer, sell, and participate in skill-based sessions. By accessing or using our Platform, you agree to comply with these Terms.</p>
            <p className="mb-3">
            Please read these Terms carefully before using the Platform. If you do not agree to these Terms, you may not use our services.
            </p>
            <Box className="mt-4">
              <h4 className="heading-color mb-2">1. Acceptance of Terms</h4>
              <p>By registering on Skill Sour, you confirm that you have read, understood, and agree to these Terms and any other policies referenced herein. Skill Sour reserves the right to change or update these Terms at any time without prior notice. The continued use of the Platform constitutes your acceptance of the modified Terms.</p>
            </Box>
            <Box className="mt-4">
              <h4 className="heading-color mb-2">2. Services Provided</h4>
              <p>Skill Sour connects individuals ("Instructors") who offer skill-based sessions with other users ("Participants") seeking to learn. The Platform allows Instructors to set up sessions, and Participants to book and attend these sessions.</p>
            </Box>
            <Box className="mt-4">
              <h4 className="heading-color mb-2">3. Session Bookings and Payments</h4>
              <p>Instructors may set their pricing and availability for sessions. Participants are required to make payments through the Platform.</p>
              <p>Skill Sour charges a service fee for facilitating the connection between Instructors and Participants. The fee will be deducted from the payment made by the Participant.</p>
              <p>All payments are processed securely through third-party payment processors.</p>
            </Box>
          </Box>
        </Box>
      </ContainerBox>
    </Box>
  );
};

export default LegalNotice;
